import {ReporteAuditoriaModel} from "@/models/bitacoras/reporte-auditoria";
import * as R from "ramda";

function evaluateModelChangedFlag(data){
  if(!data && typeof data === "boolean")return data
  if(data && typeof data === "object")return data.length>=1;
}
const modelIsModified = R.curry((mod)=>R.compose(evaluateModelChangedFlag,mod.changed)());

//Base State
function BaseStateForm(){}
// States' consctructors
export function InitialState(self){
  //Assing context
  this.data = self;
  //Reset Models and validators
  this.resetModel();
  this.resetValidators();
  //View configuration
  this.data.view.elem.button.submit.text="Buscar";

}

export function EditingState(self, reporteAuditoria){
  const {usuario, modulo, fecha, fecha_inicio, fecha_fin } = reporteAuditoria;
  this.data = self;
  this.data.reporteAuditoria = new ReporteAuditoriaModel({usuario, modulo, fecha, fecha_inicio, fecha_fin});
  this.resetValidators();
}

export function SavedState(self, {usuario, modulo, fecha}){}
// Setting Base as prototype
InitialState.prototype = Object.create(BaseStateForm.prototype);
EditingState.prototype = Object.create(BaseStateForm.prototype);
// Setting his own constructor instead of constructor's prototype
InitialState.prototype.constructor = InitialState;
EditingState.prototype.constructor = EditingState;
//Base skeleton
BaseStateForm.prototype.save   = function(){console.log("save no implementado"); return Promise.resolve()}
BaseStateForm.prototype.edit   = function(){console.log("edit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.submit = function(){console.log("submit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.resetModel = function(){this.data.reporteAuditoria = new ReporteAuditoriaModel();}
BaseStateForm.prototype.resetValidators = function(){this.data.$v.$reset();}
BaseStateForm.prototype.isDisableButtonSubmit = function(){return this.data.hasErrors(this.data.$v.reporteAuditoria)|| this.data.view.action.submit.busy}


//Editing State Implementation
EditingState.prototype.submit = async function(reporteAuditoria){
  const {usuario, modulo, fecha, fecha_inicio, fecha_fin}=reporteAuditoria;
  try{
    return this.data.isAllValid(this.data.$v);
  }catch(error){
    console.log(error);
    return error;
  }
}

EditingState.prototype.isDisableButtonSubmit = function(){
  return this.data.hasErrors(this.data.$v.reporteAuditoria) 
    || this.data.view.action.submit.busy
    || !modelIsModified(this.data.reporteAuditoria)
}



// WEBPACK FOOTER //
// ./src/views/bitacoras/reporteAuditoria/reporte-auditoria-states.js